<template>
  <div class="content-container tab-container flex-row">
    <!-- Sidebar -->
    <div class="sidebar left large fixed">
      <div class="fixed-container">
        <overlay-scrollbars :options="{ className: 'sidebar-content-container os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
          <KundeKontraktObjektTabSelgerInnlevav :objekt="objekt"/>
          <br><br>
        </overlay-scrollbars>
      </div>
    </div>
    <!-- End sidebar -->

    <KundeKontraktObjektTabSelgerBilag :objekt="objekt"/>
  </div>
</template>

<script>
import KundeKontraktObjektTabSelgerInnlevav from './KundeKontraktObjektTabSelgerInnlevav'
import KundeKontraktObjektTabSelgerBilag from './KundeKontraktObjektTabSelgerBilag'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKontraktObjektTabSelger',
  components: {
    KundeKontraktObjektTabSelgerInnlevav,
    KundeKontraktObjektTabSelgerBilag
  },
  props: {
    kunde: {
      type: Object,
      required: true
    },
    objekt: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      item: null
    }
  },
  created () {
    bus.$off('seller-invoice-created')
  },
  mounted () {
    bus.$on('seller-invoice-created', (data) => {
      if (!data.skipAlert) {
        this.$helpers.showSuccessAlert('Selger faktura er lagret')
      }

      sessionStorage.showObjektTab = 'selger'
      bus.$emit('objekt-modal-reload')
      bus.$emit('kunde-kontrakt-objekt-updated', data.objekt)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKontraktObjektTabSelger.vue